






import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TheadComponent extends Vue {
  @Prop({
    default: true
  })
  isBorder!: boolean;

  getBorder(): string {
    return this.isBorder ? "thead-component-border" : "";
  }
}
